<template>
  <div>
    <customize-page
      label-position="left"
      ref="page"
      inline
      :loading="loading"
      :data="dataList"
      :columns="columns"
      :pagination="pagination"
      :formConfig="getFormConfig()"
      :filterObj="filterObj"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    >
      <div slot="footer">
        <el-button style="margin-right: 10px" type="primary" @click="fetch">
          搜索
        </el-button>
        <el-button
          v-hp="'export'"
          style="margin-right: 10px"
          @click="exportList"
        >
          导出
        </el-button>
        <el-button style="margin-right: 10px" @click="reset">重置</el-button>
        税金(元)：{{ this.taxExpenseAmount }}
        <!--                <el-button style="margin-right:10px;">导出</el-button>-->
      </div>
    </customize-page>
  </div>
</template>

<script>
import { formatDate } from "@/utils/common";
import CustomizePage from "@/components/customize-page";
import Page from "@/mixin/Page";

import { mapActions, mapGetters, mapState } from "vuex";
import { CONST_VD_IMGPREFIX } from "@/config/constant";
import shopAuthApi from "@/api/shopAuthApi";
import authApi from "@/api/auth";
import moment from "moment";

export default {
  components: {
    CustomizePage,
  },
  mixins: [Page],
  created() {
    authApi.getOmsUserInfo().then((res) => {
      this.userInfo = res;
      this.fetch();
      this.fetchAllShop();
    });
  },
  mounted() {
    this.fetch();
  },
  data() {
    let subChannelColumn = [];
    let mailNoColumn = [];
    let customBizIdColumn = [];
    let _this = this;
    subChannelColumn.push({
      title: "子渠道名称",
      width: 200,
      key: "subBizName",
      align: "center",
    });
    subChannelColumn.push({
      title: "子渠道编码",
      width: 200,
      key: "subBizType",
      align: "center",
    });
    mailNoColumn.push({
      title: "运单号",
      width: 150,
      key: "mailNo",
      align: "center",
    });
    customBizIdColumn.push({
      title: "清单号",
      width: 150,
      key: "customsBizId",
      align: "center",
    });

    return {
      taxExpenseAmount: 0,
      loading: false,
      dataList: [],
      userInfo: {},
      shopList: [],
      columns: [
        {
          type: "selection",
          width: 50,
          align: "center",
          fixed: "left",
        },
        {
          title: "货主id",
          width: 200,
          key: "customerId",
          align: "center",
        },
        {
          title: "电商企业",
          width: 200,
          key: "enterpriseName",
          align: "center",
        },
        {
          title: "渠道",
          width: 120,
          key: "merchantName",
          align: "center",
        },
        ...subChannelColumn,
        {
          title: "商户订单号",
          key: "merchantOrderNo",
          align: "center",
          width: 150,
        },
        {
          title: "出库单号",
          key: "bizId",
          align: "center",
          width: 150,
        },
        ...customBizIdColumn,
        {
          title: "海关状态",
          width: 150,
          key: "billBusinessState",
          align: "center",
        },
        ...mailNoColumn,
        {
          title: "申报价",
          width: 150,
          key: "declaredValue",
          align: "center",
          /*                        render: (h, param) => {
                            let declaredValue = param.row.declaredValue;
                            if (declaredValue == null) {
                                return (<div>0.00</div>);
                            }
                            return <div>{(parseInt(declaredValue) / 100).toFixed(2)}</div>;
                        }*/
        },
        {
          title: "消费类型",
          width: 150,
          key: "optType",
          align: "center",
          render: (h, param) => {
            let optType = param.row.optType;
            return optType === "EXPENSE" ? (
              <span>税金消费</span>
            ) : optType === "TAX_RETURN" ? (
              <span>税金退还</span>
            ) : (
              ""
            );
          },
        },
        {
          title: "税金",
          width: 200,
          key: "taxAmount",
          align: "center",
          /*                        render: (h, param) => {
                            let taxAmount = param.row.taxAmount;
                            if (taxAmount == null) {
                                return (<div>0.00</div>);
                            }
                            return <div>{(parseInt(taxAmount) / 100).toFixed(2)}</div>;
                        }*/
        },
        {
          title: "申报时间",
          width: 180,
          key: "declareTime",
          align: "center",
        },
        // {
        //   title: "口岸",
        //   key: "portName",
        //   width: 150,
        //   align: "center"
        // },
        {
          title: "订单创建时间",
          width: 150,
          key: "gmtCreate",
          align: "center",
        },
      ],
      filterObj: {
        //portNid: "NCPORT",
        enterPriseNid: "",
        merchantOrderNo: "",
        bizId: "",
        optTypeStr: "EXPENSE",
        applyTime: [
          new Date(
            parseFloat(
              moment()
                .subtract(7, "day")
                .startOf("day")
                .format("x")
            )
          ),
          new Date(
            parseFloat(
              moment()
                .endOf("day")
                .format("x")
            )
          ),
        ],
      },
      currentRow: [],
      sortObj: {},
    };
  },
  computed: {
    ...mapGetters(["getEECommerce", "getCustomerList"]),
    ...mapState("channelStore", {
      allChannelList: "allChannelList",
    }),
    ...mapGetters(["subChannelList", "subChannelNameMapping"]),
  },
  methods: {
    ...mapActions({
      queryPageExt: "tass/pageQuery",
      submitBuildExcelTask: "tass/submitTaxExpenseBuildExcelTask",
    }),

    fetch(data) {
      this.loading = true;
      const filterParams = this.getFilterParams();
      if (filterParams.applyTime != null) {
        filterParams.orderGmtCreateStart = moment(
          filterParams.applyTime[0]
        ).format("YYYY-MM-DD HH:mm:ss");
        filterParams.orderGmtCreateEnd = moment(
          filterParams.applyTime[1]
        ).format("YYYY-MM-DD HH:mm:ss");
        delete filterParams.applyTime;
      } else {
        delete filterParams.orderGmtCreateStart;
        delete filterParams.orderGmtCreateEnd;
      }
      const sortObj = data ? data : this.sortObj;
      this.queryPageExt({
        request: {
          ...filterParams,
          pageIndex: this.pagination.currentPage,
          pageSize: this.pagination.pageSize,
        },
      })
        .then((res) => {
          this.loading = false;
          this.dataList = res.taxAccountStatementEntities || [];
          const pageInfo = res.pageInfo || { totalCount: 0 };
          this.pagination.totalCount = pageInfo.totalCount;
          this.taxExpenseAmount = res.taxExpenseAmount / 100;
        })
        .catch((error) => {
          this.$message.error(error.msg || "未知错误");
        });
    },
    selectionChange(row) {
      this.currentRow = row;
    },
    exportList(data) {
      this.loading = true;
      const filterParams = this.getFilterParams();
      if (filterParams.applyTime != null) {
        // let start = filterParams.applyTime[0] + ' 00:00:00',
        // end = filterParams.applyTime[1] + ' 23:59:59'
        filterParams.orderGmtCreateStart = filterParams.applyTime[0];
        // filterParams.orderGmtCreateStart = new Date(start).getTime();
        filterParams.orderGmtCreateEnd = filterParams.applyTime[1];
        // filterParams.orderGmtCreateEnd = new Date(end).getTime();
        delete filterParams.applyTime;
      } else {
        delete filterParams.orderGmtCreateStart;
        delete filterParams.orderGmtCreateEnd;
      }
      const sortObj = data ? data : this.sortObj;
      this.submitBuildExcelTask({
        ...sortObj,
        request: {
          ...filterParams,
          pageIndex: 1,
          pageSize: 9999,
        },
      }).then((res) => {
        if (res.value) {
          this.$alert("提交成功", "提示", {
            confirmButtonText: "确定",
            callback: (action) => {
              this.$router.push({ name: "download" });
            },
          });
        } else {
          this.$message.error("提交失败");
        }
      });
    },
    fetchAllShop() {
      return shopAuthApi
        .listAll()
        .then((res) => {
          this.shopList = res.items
            .filter((item) => {
              if (!this.userInfo.customerId) {
                return true;
              }
              return item.customerId === this.userInfo.customerId;
            })
            .map((res) => {
              return {
                label: res.shopName,
                value: res.shopCode,
                type: res.shopType,
              };
            });
        })
        .catch(() => {
          this.$message.error("店铺列表加载失败，请刷新页面重试");
        });
    },
    getFormConfig() {
      const type = this.getFormItemType();
      let subChannelConfig = [];
      subChannelConfig.push({
        label: "店铺",
        model: "subBizType",
        type: type.SELECT,
        props: {
          data: this.shopList,
        },
      });
      return [
        {
          data: [
            {
              label: "货主id",
              model: "customerId",
              type: type.SELECT,
              props: {
                data: this.getCustomerList,
              },
            },
            {
              label: "电商企业",
              model: "enterPriseNid",
              type: type.SELECT,
              props: {
                data: this.getEECommerce,
              },
            },
            {
              label: "商户订单号",
              model: "merchantOrderNo",
              type: type.INPUT,
            },
            {
              label: "出库单号",
              model: "bizId",
              type: type.INPUT,
            },
            {
              label: "渠道",
              model: "bizType",
              type: type.SELECT,
              props: {
                data: this.allChannelList,
              },
            },
            {
              label: "消费类型",
              model: "optTypeStr",
              type: type.SELECT,
              props: {
                data: [
                  {
                    label: "税金消费",
                    value: "EXPENSE",
                  },
                  {
                    label: "税金归还",
                    value: "TAX_RETURN",
                  },
                ],
              },
            },
            {
              label: "创建时间",
              model: "applyTime",
              type: type.DATETIME_RRANGE,
              className: "flex-form-item",
            },
            ...subChannelConfig,
          ],
        },
      ];
    },
  },
};
</script>
